import {useEffect, useState, useRef, forwardRef, useImperativeHandle, useContext} from 'react';

import {dBConn, AMModal} from '../API_GET'
import './support/AM_ReaperConnection.css'
import {writeFile, idsExtractor, checkPath, editorSanityCheck, ww_reaperListen} from './support/AM_ReaperConnectionSupport'
import {InfoContext} from '../AM_BackGroundOP'

//import {ww_reaperListen} from './AM_ReaperConnection_Listen';
import {ModalHeaders, modalWidth, ModalContent, ModalButtons, PromptDeteteLines} from './support/AM_ReaperConnectionModal';

export const AMKRASTHeader = forwardRef((props, ref) => {
    const [count, setCount] = useState(0);
    const ctx = useContext(InfoContext);
    
    useImperativeHandle(ref, () => ({
        updateCount: (newCount) => {
            setCount(newCount);
        }
    }));

    const openModal = (e) => {
        e.preventDefault();
        if(ctx?.amKRASTRef){
            ctx.amKRASTRef.current?.openModal();
        }
    }
    
    return  window?.electronAPI ? <li type="button" title="KRAST Editor" className="nav-item">
                <a className="nav-link nav-icon" href="/" onClick={(e) => openModal(e)} title="KRAST Editor">
                <i className="bi bi-pencil-square" />
                {count > 0 && <span className="badge bg-danger badge-number">{count}</span>}
                </a>
            </li> : null
});

export const AMKRAST = forwardRef((props, ref) => {

    const defaultSettings = {
        progress: 0,
        isDownloading: false,
        isUploading: false,
        message: "",
        dangerMessage: null,
        showModal: false,
        notOpenAnymore: false,
        listEditedFiles: [],
        services: {},
        removeAllPrompt: false,
        findIntoSessionButton: false,
        uploadTag: {
            status: false,
            name: '',
            id: null
        },
        markPost: false,
        isSeaching: false

    }
    const API = window?.electronAPI
    const ctx = useContext(InfoContext);

    const reaperSettings = useRef({
        sessionPath: '',
        tempFolder: '',
        tempFolderCheck: false,
        audioEditor: '',
        audioEditorCheck: false
    })

    const modalContentRef = useRef();

    const [moduleSettings, setModuleSettings] = useState(defaultSettings);

    // Update context count when listEditedFiles changes
    useEffect(() => {
        const count = moduleSettings.listEditedFiles.filter(l => !l.problem_found && l?.progress !== 100).length;
        // Update header badge via ref
        if (ctx?.amKRASTHeaderRef?.current) {
            ctx.amKRASTHeaderRef.current.updateCount(count);
        }
        gatherInfoFile()
    }, [moduleSettings.listEditedFiles, ctx]);

    useEffect(() => {

        if(!API) return;

        const platform = API.os.platform();
        const os = platform === 'win32' ? 'pc' : 'mac';

        dBConn(`krastAM-app-load-settings=${os}`).then(async response => {
            const tempFolderCheck = await checkPath(response.tempFolder ?? null);
            const audioEditorCheck = await checkPath(response.audioEditor ?? null);
            
            reaperSettings.current.tempFolder = response.tempFolder ?? null;
            reaperSettings.current.tempFolderCheck = tempFolderCheck;
            reaperSettings.current.audioEditor = response.audioEditor ?? null;
            reaperSettings.current.audioEditorCheck = audioEditorCheck;

            // START

            if(reaperSettings.current.tempFolderCheck) {
                API.startFolderWatch(reaperSettings.current.tempFolder).then(result => {
                    //console.log('Folder watcher avviato:', result);
                });
            
                // Global listener for file modifications
                API.onFileChanged((fileInfo) => {
                    prepExtEditorFiles(fileInfo);
                });
            }
        })

        // Listen to messages from KRAST
        API.KRASTAMListener((message) => {
            console.log('KRAST replied with:', message);
        });
 
        // Cleanup quando il componente si smonta
        return () => {
            API.removeKRASTAMListener();
            API.removeFileChangedListener();
            API.stopFolderWatch();
        };
    }, []);

    useEffect(() => {
        const cleanup = ww_reaperListen((message) => {

            if(message?.fromReaper){
                if(message.type === "uploadImportParallel"){
                    prepReaperFiles(message.data)
                }

                if(message.type === "AM_Recognition-sourcefiles-step1"){
                    AM_Recognition_Sourcefiles_step1(message.data)
                }

                if(message.type === "AM_Recognition-sourcefiles-step2"){
                    AM_Recognition_Sourcefiles_step2(message.data)
                }
            }
        });
    
        return cleanup; // Cleans up the listener when the component dismounts
    }, []);

    const ww_reaperQuest = async (props, specialActions = null, specialOnly = false, timeoutMs = 12000) => {

        return new Promise((resolve, reject) => {

            let timeoutId;
            const messageHandler = (message) => {
                try {
                    const parsedMessage = JSON.parse(message); 
                    // Check if the type matches the request
                    if(parsedMessage.type === props){
                        clearTimeout(timeoutId);
                        resolve(parsedMessage);
                    }
                } catch (error) {
                    console.error('Errore parsing messaggio Reaper:', error);
                }
            }
            // Set timeout for the request
            timeoutId = setTimeout(() => {
                alert('Reaper is not responding. Please check if Reaper is running and the connection is active.');
                reject(new Error('Reaper request timeout'));
            }, timeoutMs);
            // listener for WebSocket response
            window?.electronAPI.onReaperMessage(messageHandler);

            const request = specialOnly ? 
            specialActions : 
            `${specialActions ? `${specialActions}` : ''}SET/EXTSTATE/AMDirectConnection/request/${props};_KWSAMConnection`
            window?.electronAPI.reaperQuest(request)
            .catch((error) => {
                clearTimeout(timeoutId);
                //alert("Reaper not respond")
                reject(error);
            })
        })
    }

    const electronMessages = async (request) => {
        try {
            const ack = await window.electronAPI.AudiomateMessage({ 
                ...request,
                timestamp: Date.now()
            });
            //console.log('✅ KRAST received the message:', ack);
            return ack;
        } catch (error) {
            console.error('❌ Errore invio messaggio a KRAST:', error.message);
            throw error;
        }
    }

    /* receive from Reaper uploadImportParallel */

    const prepReaperFiles = async (data) => {

        // Process each file from Reaper array
        const processedFiles = await Promise.all(data.map(async infoFile => {
            const {path, ...rest} = infoFile;
            const audioInfo = await API.parseFile(path)
            const {sampleRate, bitsPerSample, numberOfChannels} = audioInfo.format

            return {
                ...rest,
                path: path,
                specs: {
                    sampleRate,
                    bitsPerSample,
                    numberOfChannels
                },
                //target_filename: API.path.parse(path).base,
                problem_found: infoFile.problem_found || false,
                isReaper: true
            };
        }));

        updateList(processedFiles, 'array');
    }

    /* ADD FILE TO THE LISTENER */
    const prepExtEditorFiles = async (data) => {

        const extractInfo = idsExtractor(data.path)
        const infoFile = {...data, kid: extractInfo.id, sourceTarget: extractInfo.type, isReaper: false}
        const audioInfo = await API.parseFile(data.path)

        const {sampleRate, bitsPerSample, numberOfChannels} = audioInfo.format

        const {path, ...rest} = infoFile
        const object = {
            ...rest,
            path: path,
            target_filename: API.path.parse(path).base,
            specs: {
                sampleRate,
                bitsPerSample,
                numberOfChannels
            },
            problem_found: false
        }      
        updateList(object, 'single');
    }

    const updateList = (data, mode) => {
        setModuleSettings(prev => {
            let updatedFiles;
            
            if (mode === 'single') {
                // Single file: remove existing with same kid, then add new
                const filteredList = prev.listEditedFiles.filter(file => file.kid !== data.kid);
                updatedFiles = [...filteredList, data];
            } else if (mode === 'array') {
                // Array of files: remove existing with same kid as any in array, then add all new
                const existingFiles = prev.listEditedFiles.filter(
                    existing => !data.some(newFile => newFile.kid === existing.kid)
                );
                updatedFiles = [...existingFiles, ...data];
            }
            
            return {
                ...prev,
                listEditedFiles: updatedFiles,
                type: updatedFiles.length > 0 ? 'preliminaryReaperUpload' : null,
                showModal: prev.showModal || (!prev.notOpenAnymore && updatedFiles.length > 0),
            }
        })
    }

    const gatherInfoFile = () => {

        const findIds = moduleSettings.listEditedFiles.filter(item => !item?.flag_code).map(item => item.kid);

        if(findIds.length === 0) return;

        dBConn('krastAM-app-getPreliminaryTargetInfo', findIds).then(response => {
            if(response?.success){

                const serverInfo = response.dataMerge;

                const mergedData = moduleSettings.listEditedFiles.map(item => {
                    const serverItem = serverInfo.find(server => server.id === item.kid);
                    if (!serverItem) {
                        return item;
                    }
                    const {id, ...serverData} = serverItem;
                    return {
                        ...item,
                        ...serverData
                    }
                })

                setModuleSettings(prev => {
                    // Merge with existing files, avoiding duplicates by kid
                    const existingFiles = prev.listEditedFiles.filter(
                        existing => !mergedData.some(newFile => newFile.kid === existing.kid)
                    );
                    const combinedFiles = [...existingFiles, ...mergedData];
                    
                    return {
                        ...prev,
                        listEditedFiles: combinedFiles,
                    }
                })
            }
        })
    }

    /* REMOVE FILE TO THE LISTENER */
    const deleteLine = async (data) => {

        if(data.isReaper){
            setModuleSettings(prev => {
                const updatedList = prev.listEditedFiles.filter(file => file.kid !== data.kid);
            
                return {
                    ...prev,
                    listEditedFiles: updatedList,
                };
            });
        } else {

            //const deletion = await API.deleteFile(data.path);
            //if(deletion.success){
            // Remove file from watcher tracking
                await API.untrackFile(data.path);
            
                // Remove file from listEditedFiles after successful deletion
                setModuleSettings(prev => {
                    const updatedList = prev.listEditedFiles.filter(file => file.kid !== data.kid);
                    
                    return {
                        ...prev,
                        listEditedFiles: updatedList,
                    };
                });
            //} 
        }
    }

    /* REMOVE ALL LINES */
    const promptDeleteAllLines = (e) => {
        e.preventDefault();   
        setModuleSettings(prev => ({
            ...prev,
            removeAllPrompt: true
        }));
    }

    const deleteAllLines = async (deletion) => {
        if(deletion){
            const filesToDelete = [...moduleSettings.listEditedFiles];      
            // Delete each file using deleteLine
            for (const file of filesToDelete) {
                await deleteLine(file);
            }
        }
        setModuleSettings(prev => ({
            ...prev,
            removeAllPrompt: false
        }));
        
    }

    /* REMOVE UPLOADED FILES (progress === 100) */
    const deletedUploadedFiles = async (e) => {
        e.preventDefault();
        const uploadedFiles = moduleSettings.listEditedFiles.filter(file => file.progress === 100);
        for (const file of uploadedFiles) {
            await deleteLine(file);
        }
    }

  
    // Separate download function
    const downloadFilesFromS3 = async (filesToDownload, path = '', operation) => {

        // Set download status
        setModuleSettings(prev => ({
            ...prev,
            isDownloading: true,
            progress: 0,
            message: 'Checking files...'
        }));

        // Step 1: Check that all files can be overwritten
        const fileChecks = [];
        for (const file of filesToDownload) {
            const destPath = API.path.join(path, file.localfile);
            const checkResult = await API.checkFileWritable(destPath);
            
            if (!checkResult.writable) {
                fileChecks.push({
                    file: file.localfile,
                    ...checkResult
                });
            }
        }

        // If there are locked files, show error and stop
        if (fileChecks.length > 0) {
            setModuleSettings(prev => ({
                ...prev,
                isDownloading: false,
                progress: 0,
                message: ``,
                showModal: true,
                type: 'usedFiles',
                data: fileChecks
            }));
            return 
            //throw new Error(`Locked files: ${blockedFiles}`);
        }

        // Step 2: All files are accessible, proceed with the download
        setModuleSettings(prev => ({
            ...prev,
            message: 'Start Download...'
        }));

        const infoS3 = {
            fileList: filesToDownload,
            path: 'projects-audiomate/project-'
        };

        const presignedUrls = await dBConn.post('presignedDownloadUrls', infoS3);

        if (!presignedUrls || presignedUrls.length === 0) {
            throw new Error('Nessun URL presigned ricevuto');
        }

        const downloadInfo = filesToDownload.map(item => ({
            ...item,
            url: presignedUrls.find(url => url.s3path === item.s3path)?.link
        }));

        // Download all files sequentially
        const downloadedFiles = [];
        let totalBytesDownloaded = 0;
        let totalBytesOverall = 0;
        
        for (let i = 0; i < downloadInfo.length; i++) {
            const file = downloadInfo[i];
            
            if (!file.url) {
                console.error(`Missing Url ${file.localfile}`);
                continue;
            }

            // Define the destination path
            const destPath = API.path.join(path, file.localfile);
            
            try {
                // Create directory if it does not exist
                API.createDirectory(destPath);

                let currentFileSize = 0;
                let bytesDownloadedBeforeThisFile = totalBytesDownloaded;

                // eslint-disable-next-line no-loop-func
                const progressHandler = (event) => {
                    const { received, total } = event.detail;

                    if (currentFileSize === 0 && total > 0) {
                        currentFileSize = total;
                        totalBytesOverall += total;
                    }
                    
                    totalBytesDownloaded = bytesDownloadedBeforeThisFile + received;
                    
                    const mbDownloaded = (totalBytesDownloaded / (1024 * 1024)).toFixed(2);
                    const mbTotal = totalBytesOverall > 0 ? (totalBytesOverall / (1024 * 1024)).toFixed(2) : '...';
                    
                    setModuleSettings(prev => ({
                        ...prev,
                        message: `Download file ${i + 1} of ${downloadInfo.length} (${mbDownloaded} MB / ${mbTotal} MB)`
                    }));
                };

                window.addEventListener('downloadStream-progress', progressHandler);

                // Download the file with progress
                await API.downloadStream(file.url, destPath);
                
                window.removeEventListener('downloadStream-progress', progressHandler);

                // Update downloaded bytes after file completion
                totalBytesDownloaded = bytesDownloadedBeforeThisFile + currentFileSize;

                downloadedFiles.push({
                    ...file,
                    localPath: destPath,
                    downloaded: true
                });

                // Update progress
                const progress = Math.round(((i + 1) / downloadInfo.length) * 100);
                setModuleSettings(prev => ({
                    ...prev,
                    progress
                }));

            } catch (err) {
                console.error(`Download Error ${file.localfile}:`, err);
                downloadedFiles.push({
                    ...file,
                    downloaded: false,
                    error: err.message
                });
            }
        }

        // Download completed
        setModuleSettings(prev => ({
            ...prev,
            isDownloading: true,
            progress: 100,
            message: operation
        }))

        return downloadedFiles;
    };

    const resetPopUp = () => {

        setTimeout(() => {
            setModuleSettings(prev => ({
                ...prev,
                dangerMessage: null,
                message: ""
            }))

        }, 3000)
    }



    useImperativeHandle(ref, () => ({

        electronMessages: (props) => {
            electronMessages(props)
        },

        openModal: (props) => {
            setModuleSettings(prev => ({
                ...prev,
                showModal: true,
                type: 'preliminaryReaperUpload'
            }))
        },
        showMessage: (props) => {
            alert(props);
        },
        saveUserSettings: async (newSettings) => {
            const { tempFolder, audioEditor } = newSettings;
            
            // If the tempFolder has changed, stop the old watcher
            if(reaperSettings.current.tempFolder !== tempFolder) {
                if(reaperSettings.current.tempFolderCheck) {
                    API.stopFolderWatch();
                    API.removeFileChangedListener();
                }
            }

            reaperSettings.current.tempFolder = tempFolder;
            reaperSettings.current.audioEditor = audioEditor;
            // Restart the folder watcher if the new folder is valid
            if(tempFolder) {
                API.startFolderWatch(tempFolder).then(result => {
                    //console.log('Folder watcher restarted:', result);
                });
                API.onFileChanged((fileInfo) => {
                    prepExtEditorFiles(fileInfo);
                });
            }
        },

        // import source and target in Reaper Timeline
        reaperImportSourceAndTarget: async (props) => {

            try{

                const pathOfSesion = await ww_reaperQuest('sessionPath');

                if(pathOfSesion.data.found === false){
                    setModuleSettings(prev => ({
                        ...prev,
                        dangerMessage: true,
                        message: "Reaper Session is not saved"
                    }))
                    resetPopUp()
                    return 
                }
                reaperSettings.current[pathOfSesion.type] = pathOfSesion.data.path

                const {info, filesToDownload} = props
                // 1. Download files from S3
                const downloadedFiles = await downloadFilesFromS3(filesToDownload, reaperSettings.current[pathOfSesion.type], 'Importing in Reaper...');
                if (!downloadedFiles || downloadedFiles.length === 0) {
                    return;
                }

                const infoToTxt = [
                    {pathInfo: reaperSettings.current[pathOfSesion.type]}, 
                    ...info
                ]

                const writeInfo = JSON.stringify(infoToTxt)
                const writeFileResult = await writeFile(writeInfo)             
                if(writeFileResult && filesToDownload.length !== 0){
                    const done = await ww_reaperQuest('importParallel');
                    if(done){
                        setModuleSettings(prev => ({
                        ...prev,
                        isDownloading: true,
                            progress: 100,
                            message: `Import Completed!!! (${filesToDownload.length} files)`
                        }))

                        setTimeout(() => {
                            setModuleSettings(defaultSettings)
                        }, 3000)
                    }
                }
            }
            catch(error){
                setModuleSettings(prev => ({
                    ...prev,
                    dangerMessage: true,
                    message: "Check if Reaper is running"
                }))
                resetPopUp()
            }
        },
        openInEditor: async (props) => {

            const {filesToDownload} = props
            const basePath = reaperSettings.current.tempFolder
            const sanityCheckPatches = await editorSanityCheck(reaperSettings.current)

            if(sanityCheckPatches.length > 0){
                setModuleSettings(prev => ({
                    ...prev,
                    type: 'settingsProblems',
                    showModal: true,
                    settingsProblems: sanityCheckPatches
                }))
                return;
            }

            const downloadedFiles = await downloadFilesFromS3(filesToDownload, basePath, "Opening in Editor...");
            if (!downloadedFiles || downloadedFiles.length === 0) {
                setModuleSettings(prev => ({
                    ...prev,
                    dangerMessage: true,
                    message: "No Files to donwload"
                }))
                resetPopUp()
                return;
            }

            const editor = reaperSettings.current.audioEditor
            const platform = API.os.platform();

            for (const file of downloadedFiles) {
                const audioFile = file.localPath;
                await API.trackFile(audioFile);

                let command;
                if (platform === 'win32') {
                    command = `start "" "${editor}" "${audioFile}"`;
                } else if (platform === 'darwin') {
                    command = `open -a "${editor}" "${audioFile}"`;
                } else {
                    command = `xdg-open "${audioFile}"`;
                }

                await Promise.race([
                    API.execSox(command),
                    new Promise(resolve => setTimeout(() => resolve({stderr: ''}), 2000))
                ]);
            }

            const opening = {stderr: ''}

            if(opening.stderr === ''){
                setModuleSettings(prev => ({
                    ...prev,
                    isDownloading: true,
                    progress: 100,
                    message: `Import Completed!!!`
                }))

                setTimeout(() => {
                    setModuleSettings(prev => ({
                        ...prev,
                        isDownloading: false,
                        progress: 0,
                        message: ``
                    }))
                }, 3000)
            }
        },

        findAMSourceTAG: async (props) => {

            try{
                if(props.ctrl){

                    setModuleSettings(prev => ({
                        ...prev,
                        showModal: true,
                        type: 'findInFolders',
                        findData: props.infoLine
                    }))
                    return   
                }
                
                const findElement = await ww_reaperQuest('findAMSourceTAG', `SET/EXTSTATE/AMDirectConnection/directMessage/${props.infoLine.script_data_id};`)
                if(findElement?.data === false){

                    setModuleSettings(prev => ({
                        ...prev,
                        dangerMessage: true,
                        message: "Element not found in Reaper"
                    }))
                    resetPopUp()
                }
            }
            catch(error){
                setModuleSettings(prev => ({
                    ...prev,
                    dangerMessage: true,
                    message: "Check if Reaper is running"
                }))
                resetPopUp()
            }
        }
    }));

    // open session by search
    const openSession = async (info) => {
        try{// if Reaper is running...           
            const pathOfSesion = await ww_reaperQuest('reelPath');
            const position = info?.tags[0]?.position ?? 0;
            
            if(pathOfSesion.data?.found){// if a session is already opened
                if(pathOfSesion.data.path === info.path){// check if is the same             
                    await ww_reaperQuest('setPosition', `SET/EXTSTATE/AMDirectConnection/info/${position};`)
                } else {
                    // if reaper has a session opened but is not the same
                    const session = `SET/EXTSTATE/AMDirectConnection/infopath/${info.path};`
                    const positionstring = `SET/EXTSTATE/AMDirectConnection/info/${position};`
                    await ww_reaperQuest('runSessionAndPosition', session + positionstring)
                }
            } else {
                
                // if reaper is open without real sessions
                const session = `SET/EXTSTATE/AMDirectConnection/infopath/${info.path};`
                const positionstring = `SET/EXTSTATE/AMDirectConnection/info/${position};`
                await ww_reaperQuest('runSessionAndPosition', session + positionstring)
            }
        }
        catch(err){
            // reaper is not running, run by command line
            await API.execSox(`start "" "${info.path}"`)
        }
    }


    //close modal
    const closeModal = () => {
        setModuleSettings(prev => ({
            ...prev,
            showModal: false
        }))
    }

    const updateFindInFolders = (data) => {
        setModuleSettings(prev => ({
            ...prev,
            previousPath: data
        }))
    }

    const doNotOpenAnymore = () => {
        setModuleSettings(prev => ({
            ...prev,
            notOpenAnymore: !prev.notOpenAnymore
        }))
    }

    const updateFilesToS3 = async (tagInfo) => {
        // Filter files to upload: no problems AND not already uploaded
        const filesToUpload = moduleSettings.listEditedFiles.filter(i => i.problem_found === false && i?.progress !== 100);
        const sourceTarget = {
            uploadTag: tagInfo,
            source: [],
            target: filesToUpload.map(el => el.kid)
        };

        setModuleSettings(prev => ({
            ...prev,
            isUploading: true
        }));

        const responseData = await dBConn('krastAM-gather-info-upload', sourceTarget);

        if(responseData.presignedUrls.length > 0){

            if (responseData.uploadTag) {
                setModuleSettings(prev => ({
                    ...prev,
                    uploadTag: responseData.uploadTag
                }));
            }


            // Map ALL files, but only add upload URLs to files that should be uploaded
            const insertUrls = moduleSettings.listEditedFiles.map(file => {
                const uploadUrl = responseData.presignedUrls.find(url => url.oldId === file.kid);
                
                // Only update files that are in the upload list
                if (uploadUrl) {
                    return {
                        ...file,
                        uploadUrl: uploadUrl.link,
                        progress: 0,
                        newId: uploadUrl.newId,
                        script_data_language_id: uploadUrl.script_data_language_id
                    };
                }
                // Keep other files unchanged
                return file;
            });

            // Update state with upload URLs
            setModuleSettings(prev => ({
                ...prev,
                listEditedFiles: insertUrls
            }));

            // Start parallel uploads ONLY for files in filesToUpload (using kid)
            const filesToUploadKids = filesToUpload.map(f => f.kid);
            const uploadPromises = insertUrls
                .filter(file => filesToUploadKids.includes(file.kid) && file.uploadUrl)
                .map(file => uploadFileToS3(file))

            try {
                const results = await Promise.all(uploadPromises);

                // Prepare data for ultimateUpload-targetnew endpoint
                const successfulUploads = results.filter(r => r.success && r.file.newId);
                
                if (successfulUploads.length > 0) {
                    // Format ids_target as array of strings "(newId,s3id)"
                    const ids_target = successfulUploads.map(r => {
                        return `(${r.file.newId},${r.file.newId})`;
                    })
                    
                    // Collect unique script_data_language_ids
                    const script_data_lang_ids = successfulUploads
                        .filter(r => r.file.script_data_language_id)
                        .map(r => r.file.script_data_language_id)
                    
                    const confirmData = {
                        ids_target: [ids_target], // Array of array as expected by endpoint
                        script_data_lang_ids: script_data_lang_ids
                    }

                    const confirmResponse = await dBConn('ultimateUpload-targetnew', confirmData);
                    //console.log('Upload confirmation response:', confirmResponse);
                }
                
                // Show success message
                const successCount = results.filter(r => r.success).length;
                setModuleSettings(prev => ({
                    ...prev,
                    isUploading: false,
                    progress: 100,
                    message: `Upload completed! ${successCount}/${results.length} files uploaded`
                }));

                setTimeout(() => {
                    setModuleSettings(prev => ({
                        ...prev,
                        progress: 0,
                        message: ``
                    }));
                }, 3000);
                
            } catch (error) {
                console.error('Upload error:', error);
            }
        }
    };

    const updateUploadTag = (tagData) => {
        setModuleSettings(prev => ({
            ...prev,
            uploadTag: tagData
        }));
    }

    const updateMarkPost = () => {
        setModuleSettings(prev => ({
            ...prev,
            markPost: !prev.markPost
        }));
    }

    // upload to S3
    const uploadFileToS3 = async (file) => {
        if (!file.uploadUrl) {
            console.error('No upload URL for file:', file.name);
            return { success: false, file };
        }
        try {
            // Read file from local path
            const fileBuffer = await API.fse.readFile(file.path);
            
            // Create XMLHttpRequest for progress tracking
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                
                // Track upload progress
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = Math.round((event.loaded / event.total) * 100);
                        
                        // Update progress for this specific file using kid
                        setModuleSettings(prev => ({
                            ...prev,
                            listEditedFiles: prev.listEditedFiles.map(f => 
                                f.kid === file.kid ? { ...f, progress: percentComplete } : f
                            )
                        }));
                    }
                });
                
                xhr.addEventListener('load', () => {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        resolve({ success: true, file });
                    } else {
                        reject(new Error(`Upload failed with status ${xhr.status}`));
                    }
                });
                
                xhr.addEventListener('error', () => {
                    reject(new Error('Upload failed'));
                });
                
                // Upload to S3 presigned URL
                xhr.open('PUT', file.uploadUrl);
                xhr.setRequestHeader('Content-Type', 'audio/wav'); // Adjust based on file type
                xhr.send(fileBuffer);
            });
            
        } catch (error) {
            console.error('Error uploading file:', error);
            return { success: false, file, error };
        }
    }

    /* AM_Recognition-sourcefiles */
    /* NOT YET IMPLEMENTED
    /* use to retrieve information from blank information */

    const AM_Recognition_Sourcefiles_step1 =  async (props) => {
        const info = await dBConn('krast-get-infoscript-from-sourceFiles-step1', props)
        if(info.success) {

            const obj = {
                languages: info.languages,
                ids: props
            }
            await writeFile(JSON.stringify(obj))
            await ww_reaperQuest('noInfo', `SET/EXTSTATE/AMDirectConnection/directMessage/AM_Recognition-sourcefiles-info-step1;`)

        }
    }

    const AM_Recognition_Sourcefiles_step2 = async (props) => {
        const info = await dBConn('krast-get-infoscript-from-sourceFiles-step2', props)
        //console.log(info)
    }

    const toggleFindIntoSession = (value) => {
        setModuleSettings(prev => {
            return {
                ...prev,
                findIntoSessionButton: value
            }
        })
    }

    const updateSearchingState = (isSearching) => {
        setModuleSettings(prev => ({
            ...prev,
            isSeaching: isSearching
        }))
    }

    return (<>

        {(moduleSettings.isDownloading || moduleSettings.isUploading || moduleSettings.dangerMessage) && (<div className={`alert ${moduleSettings.progress === 100 ? 'alert-success' : moduleSettings?.dangerMessage ? 'alert-danger' : 'alert-primary'} alert-dismissible show reaper-infominipanel`} role="alert">
            <div className="messages">{moduleSettings.message}</div>
            {/*<div className="download-progress-overlay">
                <div className="progress">
                    <div className="progress-bar" style={{width: `${moduleSettings.progress}%`}}>
                        {moduleSettings.progress}%
                    </div>
                </div>
            </div>*/}
            {/*<button type="button" className="btn-close dismiss" onClick={closeModal}></button>*/}
        </div>)}
        {moduleSettings.showModal && 
        <AMModal
            closeHandler={closeModal}
            width={modalWidth(moduleSettings.type)}
            header_title={<ModalHeaders data={moduleSettings} />}
            contentClass={'m-0 p-2 reaperConnectionModal'}
            buttons={<ModalButtons 
                data={moduleSettings} 
                updateFilesToS3={updateFilesToS3}
                closeModal={closeModal}
                toggleNotOpenAnymore={doNotOpenAnymore}
                promptDeleteAllLines={promptDeleteAllLines}
                deletedUploadedFiles={deletedUploadedFiles}
                searchInRpp={() => modalContentRef.current?.searchAndFind()}
                uploadTag={moduleSettings.uploadTag}
                updateUploadTag={updateUploadTag}
                markPost={moduleSettings.markPost}
                updateMarkPost={updateMarkPost}

                />}
            popupContent={moduleSettings.removeAllPrompt ? <PromptDeteteLines deleteAllLines={deleteAllLines} />
 : null}
            >
            <ModalContent ref={modalContentRef}
                data={moduleSettings}
                deleteLine={deleteLine }
                closeModal={closeModal} 
                ww_reaperQuest={ww_reaperQuest}
                updateFindInFolders={updateFindInFolders}
                openSession={openSession}
                toggleFindIntoSession={toggleFindIntoSession}
                updateSearchingState={updateSearchingState}
                electronMessages={electronMessages}/>   
        </AMModal>}
        
        
    </>);
})


